module.exports = __webpack_public_path__ + "img/구름많고비.0957d35d.png";